import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { addFreightCharge, getFilteredInvoiceList, searchFreightCharge } from "../../../api/freight";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';

import SweetAlert from "react-bootstrap-sweetalert";
import { formatValueWithCommas } from "../../helper";
import { getSASToBlob } from "../../../api/po";
const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const FreightCharges = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Freight Charge Invoice'))

    const [showList, setShowList] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedVendorName, setSelectedVendorName] = useState('');
    const [selectedInvoiceDate, setSelectedInvoiceDate] = useState('');
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState('Freight Charge was created successfully');
    const [freightNoSet, setFreightNoSet] = useState(null);
    const [file, setFile] = useState('');

    const [approvalrows, setApprovalrows] = useState([]);
    const [options, setOptions] = useState({
        fred_no: '',
        fred_no_error: '',
        quantity: '',
        quantity_error: '',
        unit_price: '',
        unit_price_error: '',
        total: '',
        conversion_rate: '',
        conversion_rate_error: '',
        amount: ''
    });
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [payload, setPayload] = useState(null);

    const handleInputChange = (value, input_name) => {
        
            let prev = {...options};
            prev[input_name] = value;

            if(input_name == 'quantity' || input_name == 'unit_price'){
                prev['total'] = Number(prev['quantity']) * Number(prev['unit_price']);
                prev['amount'] = Number(prev['total']) * Number(prev['conversion_rate']);
            }

            if(input_name == 'conversion_rate'){
                prev['amount'] = Number(prev['total']) * Number(prev['conversion_rate']);
            }

            setOptions(prev);
        
    }
    
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        {
            field: 'vendor_name',
            headerName: 'vendor Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'date',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            headerName: 'Date',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            // headerAlign: 'center',
            // cellClassName: 'center-aligndata',
        },
        {
            field: 'fred_no',
            headerName: 'Fred Number',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
        },
        {
            field: 'item',
            headerName: 'Item',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field:'Quantity',
            headerName: 'QTY',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        }, 
        {
            field: 'Unit_price',
            headerName: 'Unit Price',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },    
        {
            field: 'total',
            headerName: 'Total (Auto)',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        }, 
        {
            field: 'conversion_rate',
            headerName: 'Exchange Rate',
            headerClassName: 'break-header',
            // headerAlign: 'center',
            // cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },   
        {
            field: 'amount',
            headerName: 'Amount (Auto)',
            headerClassName: 'table-header-background',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        }, 
    ];

    const getFilteredInvoiceListFromBackend = async () => {
        try {

          const response = await getFilteredInvoiceList('FREIGHT');
            
          console.log("getFilteredInvoiceList response:", response);

          setInvoiceList(response.data?.invoiceList.map(el => ({...el, label: el.invoice_number})));

          setFreightNoSet(new Set(response.data?.setData));

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
      };

      useEffect(() => {
        getFilteredInvoiceListFromBackend();
      }, []);

    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const handleSubmit = async () => {
        try {
            let hasError = false;
            let newOptions = {...options};
            if(!newOptions.fred_no){
                newOptions.fred_no_error = 'Fred no is required!';
                hasError = true;
            } else if(freightNoSet && freightNoSet.has(newOptions.fred_no)){
                newOptions.fred_no_error = 'Fred no already exists!';
                hasError = true;
            }

            if(!newOptions.quantity){
                newOptions.quantity_error = 'Quantity is required!';
                hasError = true;
            }

            if(!newOptions.unit_price){
                newOptions.unit_price_error = 'Unit price is required!';
                hasError = true;
            }

            if(!newOptions.conversion_rate){
                newOptions.conversion_rate_error = 'Exchange rate price is required!';
                hasError = true;
            }

            if(hasError){
                setOptions(newOptions);
                return;
            }


            /*
            invoice_id: bigint,
    fred_no: string,
    quantity: number,
    unit_price: number,
    total: number,
    amount: number,
    conversion_rate: number

            */

            const data = {
                invoice_id: selectedInvoice.id,
                fred_no: options.fred_no,
                quantity: options.quantity,
                unit_price: options.unit_price,
                total: options.total,
                amount: options.amount,
                conversion_rate: options.conversion_rate
            };

            setPayload(data);

            setSubmitModalOpen(true);
            
            // const response = await addFreightCharge(payload);
            
            // if(response.statusCode == 200){
            //     setMessage(`Freight Charge was created successfully with fred no: ${response.data.freight.fred_no}`)
            //     setIsOpenSweetAlert(true);
            //         setSelectedInvoice(null);
            //         getFilteredInvoiceListFromBackend();
            // }


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }

    const submitRequisition = async () => {

       try{
        setIsLoading(true);

        if (file) {
            const response =  await getSASToBlob({uploadType:'FREIGHT'})
 
            const fetchOptions = {
                method: 'PUT',
                body: file,
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type 
                },
            }
             if(response.statusCode===200 && response.data.preSignedUrl){
                
                 try {
                     const res = await fetch(response.data.preSignedUrl, fetchOptions);
         
                     if (res.ok) {
                        payload.blob_name = response.data.blobName
                        payload.file_name = file.name
                     }
                 } catch (error) {
                     console.error('Error uploading file:', error);
                     toast.error('Error uploading file')
                     return
                 }
                 
             }
         }

            const response = await addFreightCharge(payload);
            
            if(response.statusCode == 200){
                setMessage(`Freight Charge was created successfully with fred no: ${response.data.freight.fred_no}`)
                setSubmitModalOpen(false);
                setIsOpenSweetAlert(true);
                    setSelectedInvoice(null);
                setPayload(null);

                    getFilteredInvoiceListFromBackend();
            }


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };


    useEffect(() => {
        setOptions({
            fred_no: '',
            fred_no_error: '',
            quantity: '',
            quantity_error: '',
            unit_price: '',
            unit_price_error: '',
            total: '',
            conversion_rate: '',
            conversion_rate_error: '',
            amount: ''
        });
        setSelectedVendorName('');
        setSelectedInvoiceDate('');
        setFile('');
        
        if(selectedInvoice){
            setOptions(prev => ({...prev, conversion_rate: 1}));
            setSelectedVendorName(selectedInvoice.procurementErpPODetails.VDNAME);
            setSelectedInvoiceDate(selectedInvoice.invoice_date);
        }
    }, [selectedInvoice, invoiceList]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center justify-content-between mb-2 gap-2'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>
                                                {/* Invoice No */}
                                                Freight Charge
                                                </p>
                                            <div>
                                                <Autocomplete
                                                    className="invoice_autofield"
                                                    // id={`product-category`}
                                                    sx={{ width: 190 }}
                                                    options={invoiceList}
                                                        value={selectedInvoice}
                                                        onChange={(e, value) => setSelectedInvoice(value)}
                                                    // value={productCategoryObj.find(option => option.value === productCategory)}
                                                    // onChange={handleProductCategoryChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Invoice No"
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-start gap-2">
                                            <div className="d-flex gap-2 align-items-start label_width">
                                                <p className="mb-0" style={{fontSize: '15px', fontWeight: '500', color: '#545B69', maxWidth:'190px' }}>Vendor Name :</p>
                                                <p className="mb-0" style={{ fontSize: '14px', fontWeight: '500',    wordWrap: 'break-word',
                                                    wordBreak: 'break-word',
                                                    maxWidth:'210px', 
                                                    }}>{selectedVendorName}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid rgb(175 172 172)', height: '25px'}}></div>
                                            <div className="d-flex gap-2 align-items-start label_width">
                                                <p className="mb-0 date_width" style={{fontSize: '15px', fontWeight: '500', color: '#545B69'}}>Date :</p>
                                                <p className="mb-0" style={{ fontSize: '14px', fontWeight: '500' }}>{selectedInvoiceDate}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid rgb(175 172 172)', height: '25px'}}></div>
                                            <div className="d-flex gap-2 align-items-center label_width">
                                                <p className="mb-0 date_width" style={{fontSize: '15px', fontWeight: '500', color: '#545B69'}}>Item :</p>
                                                <p className="mb-0" style={{ fontSize: '14px', fontWeight: '500' }}>Freight Charge</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3 p-3' style={{backgroundColor: '#FAFDFF', border:'1px solid #C3E8FF', borderRadius:'5px'}}>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={2}>
                                        {/* <div> */}
                                        <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Fred No"
                                                variant="outlined"
                                                value={options.fred_no}
                                        
                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'fred_no')}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%'}}
                                                
                                            />
                                            {options.fred_no_error && <span className="error-message" style={{ color: 'red' }}>{options.fred_no_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Quantity"
                                                variant="outlined"
                                                value={options.quantity}
                                        
                                                // disabled={row.productName == ''}
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                                    handleInputChange(event.target.value, 'quantity')
                                                    }
                                                }}
                                                // value={row.quantity}
                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%'}}
                                            />
                                            {options.quantity_error && <span className="error-message" style={{ color: 'red' }}>{options.quantity_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Unit Price"
                                                variant="outlined"
                                                value={options.unit_price}
                                                type="number"
                                                // disabled={row.productName == ''}
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                                    handleInputChange(event.target.value, 'unit_price')
                                                    }
                                                }}
                                                // value={row.quantity}
                                                
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.unit_price_error && <span className="error-message" style={{ color: 'red' }}>{options.unit_price_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Total"
                                                variant="outlined"
                                                value={options.total}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%', }}
                                            />
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Exchange Rate"
                                                variant="outlined"
                                                value={options.conversion_rate}
                                                type='number'
                                                // disabled={row.productName == ''}
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                                    handleInputChange(event.target.value, 'conversion_rate')
                                                    }
                                                }}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.conversion_rate_error && <span className="error-message" style={{ color: 'red' }}>{options.conversion_rate_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Amount"
                                                variant="outlined"
                                                value={options.amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 180 }}
                                                sx={{ width: '100%', }}
                                            />
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="mb-0">Freight Upload</p>
                                            <div className="upload-btn-wrapper ms-2">
                                                <button className="btn">Upload</button>
                                                <input type="file" name="myfile" onChange={(e) => onFileChange(e)} />
                                                {file && <p className="mb-0" style={{ color: "#0060AA" }}>{file.name}</p>}

                                            </div>
                                        </div>
                                        </Grid>
                                        </Grid>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end">
                                            <button className="assign_vendor" disabled={!selectedInvoice} onClick={handleSubmit}>Submit</button>
                                        </div>
                                </div>
                            </CardBody>
                        </Card>
                        {/* <div>
                            <Box sx={{ height: 400, width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                            <h4 className="mb-0 requisition_text">All Freight Charge</h4>
                                <DataGrid
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div> */}
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Freight Charge Invoice?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Fred Number</th>
                                            <th>Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Total</th>
                                            <th>Exchange Rate</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{options.fred_no}</td>
                                                <td>{options.quantity}</td>
                                                <td>{options.unit_price}</td>
                                                <td>{options.total}</td>
                                                <td>{options.conversion_rate}</td>
                                                <td>{options.amount}</td>
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default FreightCharges;
